module.exports = __webpack_public_path__ + "static/media/326.5043368a.svg";